import { random } from "lodash";
// Based on https://p5js.org/examples/simulate-snowflakes.html

interface AnimateableParticle {
  readonly x: number;
  readonly y: number;
  readonly size: number;
  update: (time: number) => void;
  display: (ctx: CanvasRenderingContext2D) => void;
}

function buildSnowflake(
  img: HTMLImageElement,
  canvasWidth: number
): AnimateableParticle {
  const SPRITE_SIZE = 64;

  class Snowflake implements AnimateableParticle {
    x: number;
    y: number;
    initialAngle: number;
    size: number;
    imgYOffset: number;
    radius: number;
    w: number;
    constructor() {
      this.x = 0;
      this.y = random(-50, 0, true);
      this.imgYOffset = random(0, 16, false) * SPRITE_SIZE;
      this.initialAngle = random(0, 2 * Math.PI, true);
      this.size = random(2, 5) * 4;
      this.w = canvasWidth - this.size;
      this.radius = Math.sqrt(random(Math.pow(this.w / 2, 2)));
    }
    update(time: number) {
      const w = 0.6; // angular speed
      const angle = w * time + this.initialAngle;
      this.x = this.w / 2 + this.radius * Math.sin(angle);

      // different size snowflakes fall at slightly different y speeds
      this.y += Math.pow(this.size, 0.5);
    }
    display(ctx: CanvasRenderingContext2D) {
      ctx.drawImage(
        img,
        0,
        this.imgYOffset,
        SPRITE_SIZE,
        SPRITE_SIZE,
        this.x,
        this.y,
        this.size,
        this.size
      );
    }
  }

  return new Snowflake();
}

function buildStep(ctx: CanvasRenderingContext2D): (time: number) => void {
  // const startOffset = performance.now(); // in ms
  const sprite = new Image();
  sprite.src = "/img/sprites.svg";
  const w = ctx.canvas.width;
  const h = ctx.canvas.height;
  let snowflakes: AnimateableParticle[] = [];
  let frameCount = 0;

  function step(/*time: number*/) {
    frameCount++;
    ctx.clearRect(0, 0, w, h);

    for (let i = 0; i < random(5, false); i++) {
      snowflakes.push(buildSnowflake(sprite, w));
    }

    const t = frameCount / 60;
    snowflakes.forEach(snowflake => {
      snowflake.update(t);
      if (0 <= snowflake.y && snowflake.y + snowflake.size < h) {
        snowflake.display(ctx);
      }
    });

    snowflakes = snowflakes.filter(
      snowflake => snowflake.y < h - snowflake.size
    );

    window.requestAnimationFrame(step);
  }
  return step;
}

export function buildAnimator(canvas: HTMLCanvasElement): null | number {
  console.log("buildAnimator", canvas.width, canvas.height);
  const ctx = canvas.getContext("2d", { alpha: true });
  if (ctx) {
    return window.requestAnimationFrame(buildStep(ctx));
  } else {
    return null;
  }
}
